import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "navigation" ]

  connect() {
  }

  open() {
    this.navigationTarget.style.height = "100%"
    document.body.classList.add('mobile-nav-open')
  }

  close() {
    this.navigationTarget.style.height = "0%"
    document.body.classList.remove('mobile-nav-open')
  }
}
